import { render, staticRenderFns } from "./vetri_new.vue?vue&type=template&id=96a7a944&"
import script from "./vetri_new.vue?vue&type=script&lang=js&"
export * from "./vetri_new.vue?vue&type=script&lang=js&"
import style0 from "./vetri_new.vue?vue&type=style&index=0&id=96a7a944&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports